import Repository from './Repository'
const resource = '/convert_bulk'

export default {
  /**
   * コンバート一括 対象サイト取得
   */
  async get() {
    return await Repository.get(`${resource}`)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * コンバート一括 送信予約 or 削除予約指示
   * @param {Array} potalsiteCds サイトCD
   * @param {Number} ids 物件ID
   * @param { String } status ステータス sending_reservation:送信 deleting_reservation:削除
   */
  async post(potalsiteCds, ids, status) {
    const params = { potalsite_cds: potalsiteCds, b_regular_id: ids, status: status }
    return await Repository.post(`${resource}`, params)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
        throw e
      })
  },
}
